module.exports = __webpack_public_path__ + "static/media/006 I GUERRA M_Ospedali militari.e1d8d025.svg";